import { ProjectTypeCodeType } from '..';

export interface GetProjectItemsRequest {
  // required
  projectId: number;
  projectTypeCode: ProjectTypeCodeType;
}
